import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TopicvizService } from '@services/topicviz/topicviz.service';

@Component({
  selector: 'app-dataset-list',
  templateUrl: './dataset-list.component.html',
  styleUrls: ['./dataset-list.component.scss'],
})
export class DatasetListComponent implements OnInit {
  public datasets: any = [];
  @Input() requestInProgress;
  @Output() changed = new EventEmitter<any>();

  constructor(private topicVizDataLoader: TopicvizService) {}

  deleteDataset(name) {
    this.requestInProgress = true;
    this.topicVizDataLoader.deleteDataset(name).subscribe(
      () => {
        this.loadAllDatasets();
        this.changed.emit();
      },
      error => {
        this.loadAllDatasets();
        alert(error['message']);
      },
    );
  }

  loadAllDatasets() {
    this.requestInProgress = true;
    this.topicVizDataLoader.loadAllDatasets().subscribe(
      response => {
        this.datasets = response;
        this.requestInProgress = false;
      },
      error => {
        alert(error['message']);
        this.requestInProgress = false;
      },
    );
  }

  ngOnInit() {
    this.loadAllDatasets();
  }
}
